module.exports = __webpack_public_path__ + "static/media/logo-jump-icon.8b092a55.svg";